import { Redirection } from '@empathy/search-types';
import { EmpathizeState, EmpathyXConfig } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { RootStoreState } from '../../store.interfaces';
import { EMPATHIZE_GETTERS_KEYS } from '../empathize.const';
import { EmpathizeGetter } from '../empathize.interfaces';

export class RedirectionsSuggestionsGetter implements EmpathizeGetter {
  getters = {
    [EMPATHIZE_GETTERS_KEYS.redirectionsSuggestions]:
      (localState: EmpathizeState, getters: any, rootState: RootStoreState, rootGetters: any): Redirection[] => {
        const { redirectionsSuggestions: config }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
        return rootState.search.directs.slice(0, config.size);
      }
  };
}
